module.exports = __webpack_public_path__ + "static/media/upk-title.ccbc8d02.svg";